import { baseApi } from "../baseApi";

export const paymenttermApi = baseApi.injectEndpoints({
     endpoints: (builder) => ({
    getPaymentTerms: builder.query({
      query: (params) => ({
        url: `/api/resource/Payment Terms Template`,
      }),
    }),

  }),
});

export const { useGetPaymentTermsQuery } = paymenttermApi;

